import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class DirectorEducationalQualification extends EntityDto implements IEntityDto {
    Qualification_Id: string;
    QualificationName: string;
    Director_Id: string;
    Qualification_Ref_Id: string;
   

    // IsActive: boolean;
    
    // TotalCount: number;
     IndexDocument: any ="";
   
    constructor() {
        super();
        this.Qualification_Id = "00000000-0000-0000-0000-000000000000";
         this.Director_Id = "";
        this.Qualification_Ref_Id = "";
    //    this.IsActive = true;
    //    this.TotalCount = 0;
  this.QualificationName="";

    }
}
